<template>
  <div id="personAvailability" v-if="personId">
    <v-card class="">
      <person-availability-table :person-id="personId" />
    </v-card>
  </div>
  <div v-else>
    <v-card class="pa-3">
      <p>No availability found</p>
    </v-card>
  </div>
</template>

<script>
import PersonAvailabilityTable from "./PersonAvailabilityTable";

export default {
  name: "Availability",
  components: { PersonAvailabilityTable },
  props: {
    personId: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style scoped>
#personAvailability {
  font-size: 14px;
}
</style>
